export default {
  title: 'Sovellukset',
  fields: {
    id: 'ID',
    name: 'Nimi',
    app_bundle_identifier: 'Sovelluspaketin tunniste',
    released: 'Julkaistu',
    franchise: 'Brändi',
    app_icon: 'Sovelluskuvake',
    status: 'Tila',
    play_store_link: 'Play Store -linkki',
    apple_store_link: 'Apple Store -linkki',
    dynamic_link: 'Dynaaminen linkki - QR-koodit',
  },
  filters: {
    name: 'Nimi',
    released: 'Julkaistu',
  },
  columns: {
    backlog: '📋 Odottaa',
    ready_to_build: '🛠️ Valmis rakennettavaksi',
    in_work: '🔧 Työn alla',
    in_review: '📝 Tarkistettavana',
    rejected: '❌ Hylätty',
    released: '✅ Julkaistu',
    deactivated: '🛑 Poistettu käytöstä',
  },
  card: {
    overdue: 'Myöhässä · {{time}}',
    copied: 'Kopioitu leikepöydälle',
    released_tag: {
      both: '✅ Julkaistu',
      ios: 'iOS julkaistu',
      android: 'Android julkaistu',
    },
    tags: {
      has_tech_issue: 'Tekninen ongelma',
    },
  },
  status_modal: {
    title: 'Päivitä julkaisutila',
    status_label: 'Tila',
    note_label: 'Huomautus (valinnainen)',
    note_placeholder: 'Lisää valinnainen huomautus tälle tilan muutokselle',
    tech_issue_checkbox: 'Kyseessä on tekninen ongelma',
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  released: {
    yes: 'Kyllä',
    no: 'Ei',
  },
  configured_status: {
    true: 'Kyllä',
    false: 'Ei',
  },
  delete_confirmation: {
    title: 'Poista mobiilisovellus',
    message: 'Haluatko varmasti poistaa tämän mobiilisovelluksen?',
    buttons: {
      confirm: 'Vahvista',
      cancel: 'Peruuta',
    },
  },
};
